<canvas
  class="whiteboard-canvas"
  id="whiteboard"
  #board
  (mousedown)="onMouseDown($event)"
  (mouseup)="onMouseUp($event)"
  (mouseout)="onMouseUp($event)"
  (mousemove)="onMouseMove($event)"
  (touchstart)="onTouchStart($event)"
  (touchend)="onTouchEnd($event)"
  (touchmove)="onTouchMove($event)"
  (touchcancel)="onTouchEnd($event)"
  (pointerdown)="$event.stopPropagation()"
  (pointerup)="$event.stopPropagation()"
  (pointermove)="$event.stopPropagation()"
  (pointercancel)="$event.stopPropagation()"
></canvas>
@if (origin == 'create-chunk') {
  <button mat-raised-button (click)="download()">
    <mat-icon>download</mat-icon>
    {{ 'Global.Download' | translate }}
  </button>
}
&nbsp;
@if (origin == 'create-chunk') {
  <button mat-raised-button (click)="eraseBoard(true)">
    <mat-icon>delete</mat-icon>
    {{ 'Global.Clear' | translate }}
  </button>
}
&nbsp;
@if (origin == 'create-chunk') {
  <button mat-raised-button (click)="uploadWhiteboard()" color="primary">
    {{ 'Global.Save' | translate }}
  </button>
}
